import React, { useEffect, useState } from 'react'
import {
    Modal, Checkbox, Button, Text, Flex, Box, tokens,
} from 'src/componentv2'
import {
    EXEMPT_EXISTING_ID_VERIFICATION_MODAL_TITLE,
    EXEMPT_EXISTING_ID_VERIFICATION_WARNING,
    EXEMPT_EXISTING_ID_VERIFICATION_CONFIRMATION_LABEL,
} from 'src/utils/onboardingPolicyCopy'

export interface ExemptVerificationModalProps {
    open: boolean
    onClose: () => void
    onConfirm: () => void
}

// Exempting returning customers removes the biometric check that ties an app re-enrollment to the
// real account holder, so this makes the institution admin explicitly acknowledge the risk before
// the exemption turns on. Declining (or dismissing) leaves the exemption off.
export const ExemptVerificationModal: React.FC<ExemptVerificationModalProps> = ({ open, onClose, onConfirm }) => {
    const [acknowledged, setAcknowledged] = useState(false)

    useEffect(() => {
        if (open) setAcknowledged(false)
    }, [open])

    return (
        <Modal open={open} onClose={onClose} title={EXEMPT_EXISTING_ID_VERIFICATION_MODAL_TITLE} maxWidth="46rem">
            <Text fontSize="1.4" color={tokens.textMuted}>
                {EXEMPT_EXISTING_ID_VERIFICATION_WARNING}
            </Text>
            <Box topMargin="1.6">
                <Checkbox
                    id="exempt-existing-id-verification-ack"
                    checked={acknowledged}
                    onChange={setAcknowledged}
                    label={EXEMPT_EXISTING_ID_VERIFICATION_CONFIRMATION_LABEL}
                />
            </Box>
            <Flex justify="flex-end" gap="1.2" topMargin="2.4">
                <Button variant="outline" onClick={onClose}>Cancel</Button>
                <Button variant="primary" onClick={onConfirm} disabled={!acknowledged}>Enable Exemption</Button>
            </Flex>
        </Modal>
    )
}

export default ExemptVerificationModal
